export const getTraiwissUrl = () => process.env.REACT_APP_MP_TRAIWISS_URL ?? 'http://localhost:3000'

export const getBaseUrl = () => process.env.REACT_APP_MP_BASE_URL ?? 'http://localhost:3009'

export const getMediaUrl = () => process.env.REACT_APP_MP_MEDIA_URL ?? 'http://localhost:3000/api/media'
